module.exports = __webpack_public_path__ + "media/images/redesign-images/rewards/vip-icons-01-13106103ec35ca546fa0bfe5e1bb3ece.png";